import { Box } from '@mui/material';
import { FC, ReactNode, useContext, useEffect, useState } from 'react';

import { RightPanelContext } from '@sh4res/bo-common/components/ShowWithNavigation';
import { getSpaceAboveFooter } from '@sh4res/bo-common/utils';

type FixedButtonProps = {
  children: ReactNode;
  id?: string;
  'data-testid'?: string;
};

export const FixedButton: FC<FixedButtonProps> = ({
  children,
  id = 'edit-btn',
  'data-testid': dataTestId,
}) => {
  const rightPanelContext = useContext(RightPanelContext);
  const [buttonBottom, setButtonBottom] = useState(getSpaceAboveFooter());

  useEffect(() => {
    const mainContent = document.querySelector('#main-content');

    if (!mainContent) {
      return;
    }

    const handleScroll = () => {
      setButtonBottom(getSpaceAboveFooter());
    };

    mainContent.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => mainContent.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Box
      id={id}
      data-testid={dataTestId}
      sx={{
        position: 'fixed',
        bottom: buttonBottom,
        right: rightPanelContext.isOpen ? '475px' : '75px',
        zIndex: 99999,
        '& .MuiButton-root': {
          height: '30px',
        },
        transition: 'bottom 0.3s ease',
      }}>
      {children}
    </Box>
  );
};
